module.exports = __webpack_public_path__ + "img/homeicon.b210eadb.svg";